import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { type SeoJobRoleLocations } from '@xing-com/crate-common-graphql-types';
import { Link } from '@xing-com/link';

const renderCity = (city?: SeoJobRoleLocations): React.ReactNode => {
  if (!city?.name) {
    return null;
  }

  return city.url ? <Link to={city.url}>{city.name}</Link> : city.name;
};

export const CitiesFormattedMessage = (
  jobRole: string,
  cities: Array<SeoJobRoleLocations>
): React.ReactNode => {
  switch (cities.length) {
    case 0:
      return;
    case 1:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_ANSWER"
          values={{
            jobRole,
            firstCity: renderCity(cities[0]),
          }}
        />
      );
    case 2:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_CITIES_ANSWER"
          values={{
            jobRole,
            firstCity: renderCity(cities[0]),
            secondCity: renderCity(cities[1]),
          }}
        />
      );
    default:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_CITIES_ANSWER"
          values={{
            jobRole,
            firstCity: renderCity(cities[0]),
            secondCity: renderCity(cities[1]),
            thirdCity: renderCity(cities[2]),
          }}
        />
      );
  }
};
